import { render, staticRenderFns } from "./RequestLetterSodorEsterdad.vue?vue&type=template&id=5912f858&scoped=true&"
import script from "./RequestLetterSodorEsterdad.vue?vue&type=script&lang=js&"
export * from "./RequestLetterSodorEsterdad.vue?vue&type=script&lang=js&"
import style0 from "./RequestLetterSodorEsterdad.vue?vue&type=style&index=0&id=5912f858&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5912f858",
  null
  
)

export default component.exports